import { useTheme } from '@mui/material';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { CustomIcon } from 'modules/components/layer00';
import { SaveInstallationForm } from 'modules';
import React from 'react';
import { useParams } from 'react-router-dom';



export type SaveInstallationModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveInstallationModalProps) => {
  const theme = useTheme();
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      title={`${props.id === '' ? 'Save' : 'Edit'} Finish`}
      subTitle='Enter Finish information below'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      headerIcon={(
        <CustomIcon.large.FC
          icon='PLUS'
          stroke={theme.palette.primary.main}
        />
      )}
      id={props.id}
    >
      <SaveInstallationForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={() => props.handleClose()}
      />
    </BasicFormModalLayout.FC>
  );
};
